import React from 'react';
import PropTypes from 'prop-types';

import styles from './loader.scss';

const classNames = require('classnames');

const SMALL = 'small';
const MEDIUM = 'medium';
const LARGE = 'large';

class Loader extends React.Component {
  render = () => {
    const { size, className } = this.props;
    return <i className={classNames(className, styles.loader, styles[size])} />;
  };
}

Loader.propTypes = {
  size: PropTypes.oneOf([SMALL, MEDIUM, LARGE]),
  className: PropTypes.string,
};

Loader.defaultProps = {
  size: MEDIUM,
};

export default Loader;
